"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Loading = _interopRequireDefault(require("./../Loading/Loading"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _string = require("../../utils/type-checks/string");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Redirects users to External URL
 *
 * @visibleName Redirect
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
const Redirect = props => {
  const {
    customTheme = {},
    hideIcon = false,
    location,
    styles = {},
    tag = "h1",
    testId
  } = props;
  (0, _react.useEffect)(() => {
    if ((0, _string.isStringOfLength)(location)) {
      window.location.href = location;
    }
  }, [location]);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, (0, _string.isStringOfLength)(location) && /*#__PURE__*/_react.default.createElement(_Loading.default, {
    customTheme: customTheme,
    hideIcon: hideIcon,
    styles: styles,
    tag: tag,
    testId: testId
  }, "Redirecting to ", /*#__PURE__*/_react.default.createElement("a", {
    href: location
  }, location)));
};
Redirect.propTypes = {
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Boolean to show/hide loading icon (Default Value: false) */
  hideIcon: _propTypes.default.bool,
  /** External URL to sent user to */
  location: _propTypes.default.string.isRequired,
  /** Custom styles object (Default Value: {}) */
  styles: _propTypes.default.object,
  /** Heading tag used by Loading component (Default Value: "h1") */
  tag: _propTypes.default.string,
  /** @ignore */
  testId: _propTypes.default.string
};
var _default = exports.default = Redirect;